export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/LayoutWorker.3d958fa9.worker.js");
}
